import { Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import { useSelector } from "react-redux";

const ReviewAndRun = () => {
  const {
    brandDataInModal,
    startDate,
    endDate,
    selectedAction,
    selectedBrandConfigs,
    selectedUnifierDestinationTableId,
    selectedBusinessAdvisorDestinationTableId,
  } = useSelector((state: any) => state.dataCollectionBrands);

  // Extracting brand names from the brandDataInModal
  const selectedBrandsForEndToEndSync = Array.isArray(brandDataInModal)
    ? brandDataInModal
        .map((item: { brandName: string }) => item.brandName)
        .join(", ")
    : "";
  const selectedBrandsForFetcher = Array.isArray(selectedBrandConfigs)
    ? selectedBrandConfigs
        .map((item: { brandName: string }) => item.brandName)
        .join(", ")
    : "";
  const formatDateForUI = (dateStr: string) => {
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return dateStr; // fallback if invalid
    return date.toLocaleDateString("en-GB"); // dd/mm/yyyy format
  };
  return (
    <Stack mt={2} flexDirection={"column"} gap={2}>
      <Stack flexDirection={"row"} gap={2}>
        <Stack flexDirection={"row"} gap={2} mt={2}>
          <Typography fontWeight="500" fontSize={14}>
            Selected Brand:{" "}
            <Typography component="span" fontSize={14}>
              {selectedAction === "End_to_end_sync" ||
              selectedAction === "Unifier"
                ? selectedBrandsForEndToEndSync
                : selectedBrandsForFetcher}
            </Typography>
          </Typography>
        </Stack>
        <Stack flexDirection={"row"} gap={2} mt={2}>
          <Typography fontWeight="500" fontSize={14}>
            Start Date:{" "}
            <Typography component="span" fontSize={14}>
              {formatDateForUI(startDate)}
            </Typography>
          </Typography>
        </Stack>
        <Stack flexDirection={"row"} gap={2} mt={2}>
          <Typography fontWeight="500" fontSize={14}>
            End Date:{" "}
            <Typography component="span" fontSize={14}>
              {formatDateForUI(endDate)}
            </Typography>
          </Typography>
        </Stack>
      </Stack>
      {selectedAction === "End_to_end_sync" && (
        <>
          <Typography fontWeight="500" fontSize={14}>
            End to end process
          </Typography>
        </>
      )}
      {selectedAction === "Fetcher" && (
        <>
          {selectedBrandConfigs?.map((brand: any) => (
            <Box key={brand.brandId}>
              <Typography fontWeight="500" fontSize={14}>
                {selectedAction} Processes for {brand.brandName}:
              </Typography>
              <Typography component="div" fontSize={14} mt={0.5}>
                {brand.selectedConfigs.length > 0 ? (
                  brand.selectedConfigs.map((cfg: any, idx: number) => (
                    <Typography key={cfg.tableId} component="span">
                      {cfg.configName} ({cfg.tableId})
                      {idx !== brand.selectedConfigs.length - 1 && ", "}
                    </Typography>
                  ))
                ) : (
                  <Typography component="span" fontStyle="italic">
                    No configs selected
                  </Typography>
                )}
              </Typography>
            </Box>
          ))}
        </>
      )}
      {selectedAction === "Unifier" && (
        <Box>
          <Typography fontWeight="500" fontSize={14}>
            Unifier Processes:
          </Typography>
          <Typography component="div" fontSize={14} mt={0.5}>
            {selectedUnifierDestinationTableId.length > 0 ? (
              selectedUnifierDestinationTableId.map((cfg: any, idx: number) => (
                <Typography key={cfg.destinationTableId} component="span">
                  {cfg.configName}
                  {idx !== selectedUnifierDestinationTableId.length - 1 && ", "}
                </Typography>
              ))
            ) : (
              <Typography component="span" fontStyle="italic">
                No configs selected
              </Typography>
            )}
          </Typography>
        </Box>
      )}
      {selectedAction === "business_advisor" && (
        <Box>
          <Typography fontWeight="500" fontSize={14}>
            Business Advisor Processes:
          </Typography>
          <Typography component="div" fontSize={14} mt={0.5}>
            {selectedBusinessAdvisorDestinationTableId.length > 0 ? (
              selectedBusinessAdvisorDestinationTableId.map(
                (cfg: any, idx: number) => (
                  <Typography key={cfg.destinationTableId} component="span">
                    {cfg.configName}
                    {idx !==
                      selectedBusinessAdvisorDestinationTableId.length - 1 &&
                      ", "}
                  </Typography>
                )
              )
            ) : (
              <Typography component="span" fontStyle="italic">
                No configs selected
              </Typography>
            )}
          </Typography>
        </Box>
      )}
    </Stack>
  );
};

export default ReviewAndRun;
